import { useQuery } from "@tanstack/react-query";

import { gatewayPhone } from "src/gateways/gatewayPhone";

import { IContactCenterUsageSummary, IContactCenterUsageSummaryApiResponse } from "../interfaces/billingSubscriptions.interface";

export const useContactCenterUsageSummaryQuery = (billingPeriod?: string) => {
  return useQuery<IContactCenterUsageSummary>({
    queryKey: ["contact-center", "usage-summary", billingPeriod],
    queryFn: async () => {
      const response = await gatewayPhone.get<IContactCenterUsageSummaryApiResponse | IContactCenterUsageSummary>("/usage/contact-center-summary", {
        params: {
          billingPeriod,
        },
      });

      return "data" in response.data && response.data.data ? response.data.data : (response.data as IContactCenterUsageSummary);
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
    retry: 1,
  });
};
